import { useQuery } from '@tanstack/react-query';
import { CustomPageType } from '../../extViewmodels/sdk/models/CustomPageStyle';
import { useApiClientContext } from '../contexts/apiClient';

const BASE_QUERY_KEY = 'ScheduleMeetingCustomPageStyle';

interface CustomPageStyleResponse {
	html?: string;
	hasCustomization: boolean;
	error?: string;
}

export const useCustomPageStyleByShortCode = ({
	shortCode,
	type,
	enabled = true,
}: {
	shortCode?: string;
	type: CustomPageType;
	enabled?: boolean;
}) => {
	const { apiClient } = useApiClientContext();

	return useQuery<CustomPageStyleResponse>({
		enabled: enabled && !!shortCode,
		queryFn: async (): Promise<CustomPageStyleResponse> => {
			try {
				const response = await fetch(`${apiClient.baseUrl}/scheduler/${shortCode}/custom-page-style/${type}`);

				const htmlContent = await response.text();

				if (!htmlContent || htmlContent.trim() === '') {
					return { hasCustomization: false, error: 'Empty response received' };
				}

				return {
					hasCustomization: true,
					html: htmlContent,
				};
			} catch (networkError) {
				console.error('Network error fetching custom page style:', networkError);
				return { hasCustomization: false, error: 'Network error occurred' };
			}
		},
		queryKey: [BASE_QUERY_KEY, shortCode, type],
		retry: (failureCount, error) => {
			// Only retry on network errors, not on 4xx client errors
			return failureCount < 2 && !(error as any)?.message?.includes('HTTP 4');
		},
	});
};
